import { IMemberContact } from './memberContact';
import { IMemberEmergencyContact } from './memberEmergencyContact';
import { IMemberFreezeDetail } from './memberFreezeDetail';
import { IMemberFeeDetails } from './feeDetail';
import { IAttendance } from './attendance';
import { ISettings } from './settings';
import { Customerstrainer } from './Customerstrainer';
import { IMemberPaymentOnRegistration } from './paymentOnRegistration';

export class IMember {
    _id: string;
    name: string;
    dateOfBirth: Date;
    email: string;
    gender: string;
    password: string;
    profile: string;
    tagNumber: string;
    oldSystemId: string;
    noteDetails: string;
    description: string;
    joiningDate: Date;
    registerationFee: string;
    totalRegisterationFee: string;
    trainingFee: string;
    monthFee: string;
    feeDetails: IMemberFeeDetails[];
    paymentOnRegistration: IMemberPaymentOnRegistration;
    attendance: IAttendance[];
    contactDetail: IMemberContact;
    freezeDetail: IMemberFreezeDetail;
    emergencyContact: IMemberEmergencyContact;
    customerstrainer: Customerstrainer;
    relatedMember: IRelatedMember[];
    profession: string;
    question1: string;
    question2: string;
    question3: string;
    gPTQuestion: string;
    settings: ISettings;
    branch: string;
    branchName:String;
    company: string;
    isDelete: boolean;
    biometricData: string;
    isBiometricVerified: boolean;
    packageType: string;
    packageName: string
    packageId: string;
    secondaryPackages: ISecondaryPackage[] = [];
    cardNo: string;
    customerPackageFee: number;
    packageLogo: string;
    selectedPaid: boolean = false;
    isSynced = false;
    isLocked = false;
    isDefaulter: boolean;
    // covidImageUrl: string;
    CNIC: string;
    CNICImageUrl: string;
    oldDate: Date;
    currentUserData: any;
    type: any;
    scope: any;
    oldValue: any;
    memberSettingFlag: boolean;
    initiatedFrom: any;
    createdBy: string;
    enquiryId: string;
    acknowledgedImage: string;
    bloodGroup: string;
    paymentMode: string;
    trainerId: string;
    trainerName: string;
    walletAmount: any;
    height: string;
    weight: string;
    referralSource: string;
    referralOther: string;
    freezeRequest: IFreezeRequest[];
    packageHistory: IPackageHistory[];
    Biometrics?: {
        fingerprint?: boolean;
        face?: boolean;
    };
    relatedMembersId: string;
}

export class IPackageHistory {
    packageId: string;
    packageName: string;
    startDate: string | Date;
    endDate: string | Date | null;
}

export class ISecondaryPackage {
    packageId: string;
    packageName: string;
    assignedDate?: string | Date;
}

export class IFreezeRequest {
    _id: string;
    days: string;
    startDate: string;
    endDate: string;
    status: string;
    requestedBy: string;
    completedDate?: string;
}
class IRelatedMember {
    name: string;
    memberId: string;
    phone: string;
    packageId: string;
    tagNumber: string;
}